import { useMemo } from "react";
function useFormattedDate(dateString) {
    const formatted = useMemo(()=>{
        if (!dateString) return;
        const date = new Date(dateString);
        const monthDay = date.toLocaleDateString('en-US', {
            month: 'short',
            day: 'numeric'
        });
        const time = date.toLocaleTimeString('en-US', {
            hour: 'numeric',
            minute: '2-digit'
        }).toLowerCase();
        return `${monthDay} at ${time}`;
    }, [
        dateString
    ]);
    return formatted;
}
const hooks_useFormattedDate = useFormattedDate;
export { hooks_useFormattedDate as default };
